/* Milk Mob collection filtering: instant size chips, in-stock switch, filter drawer, load more. */
(() => {
  if (customElements.get('mm-collection')) return;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  class MmFilterDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = $('.mm-drawer__panel', this);
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-mm-close]')) this.close();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    open(opener) {
      this.opener = opener;
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.body.classList.add('overflow-hidden');
      if (typeof window.trapFocus === 'function') window.trapFocus(this.panel, this.panel);
      else this.panel.focus();
    }

    close() {
      if (this.hidden) return;
      this.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
      if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(this.opener);
      else if (this.opener) this.opener.focus();
      setTimeout(() => { this.hidden = true; }, 380);
    }
  }
  customElements.define('mm-filter-drawer', MmFilterDrawer);

  class MmCollection extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.baseUrl = this.dataset.baseUrl || window.location.pathname;
      this.controller = null;
      this.debounce = null;

      this.addEventListener('change', (event) => this.onChange(event));
      this.addEventListener('input', (event) => {
        if (event.target.matches('.mm-price input')) {
          clearTimeout(this.debounce);
          this.debounce = setTimeout(() => this.update(), 700);
        }
      });
      this.addEventListener('submit', (event) => {
        event.preventDefault();
        this.update();
      });
      this.addEventListener('click', (event) => this.onClick(event));
      window.addEventListener('popstate', () => this.render(window.location.search.slice(1), false));
    }

    get form() {
      return $('[data-mm-facets]', this);
    }

    onChange(event) {
      const input = event.target;
      if (input.matches('[data-mm-group]')) {
        // Keep the toolbar chip and the drawer chip for the same size in step.
        $$(`[data-mm-group="${input.dataset.mmGroup}"]`, this).forEach((twin) => {
          twin.checked = input.checked;
          twin.closest('.mm-chip')?.classList.toggle('is-active', input.checked);
        });
      }
      if (input.name === 'filter.v.availability') {
        // The toolbar switch and the pop-up switch are the same filter.
        $$('input[name="filter.v.availability"]', this).forEach((twin) => { twin.checked = input.checked; });
      }
      if (input.matches('.mm-price input')) return;
      if (input.closest('[data-mm-facets]')) this.update();
    }

    onClick(event) {
      const opener = event.target.closest('[data-mm-open-filters]');
      if (opener) {
        event.preventDefault();
        $('mm-filter-drawer', this)?.open(opener);
        return;
      }

      const clear = event.target.closest('[data-mm-clear]');
      if (clear) {
        event.preventDefault();
        const keep = new URLSearchParams();
        const q = new URLSearchParams(window.location.search).get('q');
        if (q) keep.set('q', q);
        const sort = $('[name="sort_by"]', this);
        if (sort && sort.value && sort.value !== sort.dataset.default) keep.set('sort_by', sort.value);
        this.render(keep.toString());
        return;
      }

      const removeGroup = event.target.closest('[data-mm-remove-group]');
      if (removeGroup) {
        $$(`[data-mm-group="${removeGroup.dataset.mmRemoveGroup}"]`, this).forEach((i) => { i.checked = false; });
        this.update();
        return;
      }

      const removeName = event.target.closest('[data-mm-remove-name]');
      if (removeName) {
        const { mmRemoveName: name, mmRemoveValue: value } = removeName.dataset;
        $$(`[name="${CSS.escape(name)}"]`, this).forEach((i) => {
          if (value === undefined || i.value === value) i.checked = false;
        });
        this.update();
        return;
      }

      const removePrice = event.target.closest('[data-mm-remove-price]');
      if (removePrice) {
        event.preventDefault();
        $$('.mm-price input', this).forEach((i) => { i.value = ''; });
        this.update();
        return;
      }

      const more = event.target.closest('[data-mm-load-more]');
      if (more) {
        event.preventDefault();
        this.loadMore(more);
      }
    }

    params() {
      const form = this.form;
      const params = new URLSearchParams();
      if (!form) return params;
      const sizeParam = form.dataset.sizeParam || 'filter.v.option.size';
      const sizes = new Set();
      $$('[data-mm-group]:checked', form).forEach((input) => {
        input.dataset.values.split(',').filter(Boolean).forEach((v) => sizes.add(v));
      });
      new FormData(form).forEach((value, key) => {
        if (value === '' || value === null) return;
        if (key === 'sort_by') {
          const select = $('[name="sort_by"]', form);
          if (select && value === select.dataset.default) return;
        }
        params.append(key, value);
      });
      sizes.forEach((v) => params.append(sizeParam, v));
      const seen = new Set();
      const unique = new URLSearchParams();
      params.forEach((value, key) => {
        const id = `${key}=${value}`;
        if (seen.has(id)) return;
        seen.add(id);
        unique.append(key, value);
      });
      return unique;
    }

    update() {
      this.render(this.params().toString());
    }

    async render(query, push = true) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.classList.add('is-loading');
      const url = `${this.baseUrl}${query ? `?${query}` : ''}`;
      const fetchUrl = `${this.baseUrl}?${query ? `${query}&` : ''}section_id=${this.sectionId}`;
      try {
        const response = await fetch(fetchUrl, { signal: this.controller.signal });
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const focusedId = document.activeElement && this.contains(document.activeElement) ? document.activeElement.id : null;
        const focusedGroup = document.activeElement?.dataset?.mmGroup;
        const inDrawer = document.activeElement?.closest('mm-filter-drawer');

        $$('[data-mm-region]', this).forEach((region) => {
          const next = doc.querySelector(`[data-mm-region="${region.dataset.mmRegion}"]`);
          if (!next) return;
          if (region.dataset.mmRegion === 'active') region.replaceWith(next);
          else region.innerHTML = next.innerHTML;
        });

        if (push) window.history.pushState({ mm: true }, '', url);
        if (focusedId && document.getElementById(focusedId)) document.getElementById(focusedId).focus();
        else if (focusedGroup) {
          const scope = inDrawer ? $('mm-filter-drawer', this) : $('[data-mm-toolbar]', this);
          $(`[data-mm-group="${focusedGroup}"]`, scope || this)?.focus();
        }
        const toolbar = $('[data-mm-toolbar]', this);
        if (toolbar && toolbar.getBoundingClientRect().top < 0) {
          window.scrollTo({ top: window.scrollY + this.getBoundingClientRect().top - 8, behavior: 'smooth' });
        }
        this.dispatchEvent(new CustomEvent('mm:results', { bubbles: true }));
      } catch (error) {
        if (error.name !== 'AbortError') window.location.href = url;
      } finally {
        this.classList.remove('is-loading');
      }
    }

    async loadMore(link) {
      const grid = $('[data-mm-grid]', this);
      if (!grid || link.classList.contains('is-loading')) return;
      link.classList.add('is-loading');
      const next = new URL(link.href, window.location.origin);
      next.searchParams.set('section_id', this.sectionId);
      try {
        const html = await (await fetch(next.toString())).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = $$('[data-mm-grid] > li', doc);
        items.forEach((item) => grid.appendChild(item));
        const newMore = $('[data-mm-more]', doc);
        const oldMore = $('[data-mm-more]', this);
        if (oldMore) {
          if (newMore) {
            const prev = $('.mm-more__prev', newMore);
            if (prev) prev.remove();
            oldMore.replaceWith(newMore);
          } else oldMore.remove();
        }
        const firstNew = items[0]?.querySelector('a');
        if (firstNew) firstNew.focus({ preventScroll: true });
      } catch (error) {
        window.location.href = link.href;
      }
    }
  }
  customElements.define('mm-collection', MmCollection);
})();
